//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { OnlineResourceBehaviour } from './Enums';

export class LibraryOnlineDisplayItem extends ItemBase {
    Description: string | null = null;
    Downloads: number | null = null;
    DownloadURL: string | null = null;
    Filename: string | null = null;
    Hidden: boolean = false;
    AllowDownload: boolean = false;
    ID: string | null = null;
    Behaviour: OnlineResourceBehaviour = OnlineResourceBehaviour.None;
    IsFolder: boolean = false;
    Size: number | null = null;
    ViewURL: string | null = null;
    ContainingFolderID: string | null = null;
    UploadedByTeacherID: string | null = null;
    SpaceID: string | null = null;
    CanEdit: boolean = false;
    VisibleToAll: boolean = false;
    ContainingFolder: LibraryOnlineDisplayItem | null = null;
    ContainingFolderHierarchyIDs: string[] = [];
    FileCountInFolder: number | null = null;
    FolderCountInFolder: number | null = null;
    StudentIDs: string[] = [];
    TagIDs: string[] = [];
    IsAttachedToAttendance: boolean | null = null;

    constructor(initializer?: Partial<LibraryOnlineDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "LibraryOnlineDisplayItem";
}
